module.exports = __webpack_public_path__ + "5c114213/img/arrow-export-icon.a3345173.svg";